import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import ArchiveItemViewModel from '../viewModels/archiveItemViewModel';
import ArchiveCell from './archiveCell';

export interface CatalogArchiveTableProps {
  items: ArchiveItemViewModel[];
}

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    table: {
      minWidth: 650,
    },
  })
);

const CatalogArchiveTable: React.FunctionComponent<CatalogArchiveTableProps> =
  observer(props => {
    const classes = useStyles();

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Navn</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.items.map(archive => (
              <ArchiveCell archive={archive} key={archive.id} />
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  });

export default CatalogArchiveTable;
